<template>
  <div class="container-fluid">
    <loading v-if="loadingRender"></loading>
    <div v-if="ShowEmpty" class="row">
      <div class="col-12 border border-danger my-4 py-3 rounded">
        <h5>فایلی روی سرور موجود نبود!</h5>
      </div>
    </div>
    <div v-else class="row">
      <div
        v-for="(item, index) in Files"
        :key="index"
        class="col-md-3 col-12 p-4"
      >
        <div class="m-2">
          <div class="row rounded border p-2">
            <div class="col-md-12 col-4 my-3 text-center">
              <img
                :src="ReturnIcone(item.filename)"
                alt="item.filename"
                style="max-width: 100%"
              />
              <hr />
            </div>
            <div class="col-md-12 col-4">
              <span>
                <i class="font-weight-bold"> نام فایل: </i>
                <i>
                  {{ item.filename }}
                </i>
              </span>
              <hr />
            </div>
            <div class="col-md-12 col-4">
              <div v-if="$session.get('IsRahbar')" class="row">
                <div class="col-md-4 col-12">
                  <a
                    :download="item.filename"
                    title="دانلود فایل"
                    :href="
                      'data:application/octet-stream;base64,' + item.binary
                    "
                    class="btn btn-secondary w-100"
                    style="font-size: 15px"
                  >
                    <i class="fas fa-download"></i
                  ></a>
                </div>
                <div class="col-md-4 col-12">
                  <button
                    @click="Delete(item.id)"
                    class="btn btn-dark w-100"
                    style="font-size: 15px"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
                <div class="col-md-4 col-12">
                  <button
                    v-if="
                      item.wwwtblcomboidgrp328 == 100 ||
                      item.wwwtblcomboidgrp328 == 101 ||
                      item.wwwtblcomboidgrp328 == 102
                    "
                    @click="GetfileEmza(item.id)"
                    class="btn btn-dark w-100"
                    style="font-size: 15px"
                  >
                    <i class="fas fa-signature"></i>
                  </button>
                </div>
              </div>
              <div v-else class="row">
                <div class="col-md-6 col-12">
                  <a
                    :download="item.filename"
                    title="دانلود فایل"
                    :href="
                      'data:application/octet-stream;base64,' + item.binary
                    "
                    class="btn btn-secondary w-100 text-center"
                    style="font-size: 15px"
                  >
                    دریافت فایل<i class="fas fa-download"></i
                  ></a>
                </div>
                <div class="col-md-6 col-12">
                  <button
                    v-if="
                      item.wwwtblcomboidgrp328 == 100 ||
                      item.wwwtblcomboidgrp328 == 101 ||
                      item.wwwtblcomboidgrp328 == 102
                    "
                    @click="GetfileEmza(item.id)"
                    class="btn btn-dark w-100"
                    style="font-size: 15px"
                  >
                    <i class="fas fa-signature"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loading from "../../Tools/NetPa/Loading.vue";
export default {
  data() {
    return {
      Tablekey: 0,
      ShowEmpty: false,
      Files: [],
      IsEmza: false,
      loadingRender: false,
    };
  },
  props: ["IsAdmin"],
  components: {
    loading,
  },
  methods: {
    GetFile() {
      this.ShowEmpty = false;
      this.loadingRender = true;

      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: this.$session.get("CustCode"),
          tableName: "ExtraForms",
        },
      };
      this.$PostData(dataAxios).then((result) => {
        this.loadingRender = false;

        this.file = result.data;
        this.Tablekey++;
        if (result.data == null || result.data.length == 0) {
          this.ShowEmpty = true;
        } else {
          this.Files = result.data;
        }
      });
    },
    GetfileEmza(id) {
      console.log(id);

      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetfileEmza",
        ArryfildValue: {
          Id: id,
        },
      };
      this.$PostData(dataAxios).then((result) => {
        console.log(result);
      });
    },
    Delete(id) {
      this.$SweetQustion(
        "درخواست حذف فایل",
        "از حذف فایل انتخابی خود اطمینان دارید ؟",
        "warning",
        "حــذف",
        "انصراف",
        id,
        this.ConfirmDelete,
        this.Cancel
      );
    },
    ConfirmDelete(id) {
      var axios = {
        Method: "POST",
        Action: "Uploader/Delete",
        ArryfildValue: { Id: id },
      };
      this.$PostData(axios).then((result) => {
        this.$mySweetDefaultTost(result.title, result.msg, result.icon, 2000);
        this.GetFile();
      });
    },
    ReturnIcone(name) {
      var ex = name.split(".").pop();
      if (["rar", "zip"].includes(ex)) {
        return "/Image/ZipFile.png";
      }
      if (["pdf"].includes(ex)) {
        return "/Image/PDFFileEx.png";
      }
      if (["png", "jpg", "jpeg"].includes(ex)) {
        return "/Image/Image.png";
      }
    },
  },
  created() {
    this.GetFile();
  },
};
</script>
